import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useUnit } from "effector-react";
import { $goalsStore, fetchGoalsRequested } from "../store";
import { GoalsList as GoalsListComponent } from "../components/GoalsList";
import { EmptyState } from "../components/EmptyState";
import { CreateGoalModal } from "../components/CreateGoalModal";
import Loader from "@/core/components/loader/Loader";
import Tracking from "@/core/utils/tracking";
import { goalsService } from "../service";
import { SEO } from "@/core/components/SEO/SEO";

export const GoalsList: React.FC = () => {
  const navigate = useNavigate();
  const { goals, loading, error } = useUnit($goalsStore);
  const fetchGoals = useUnit(fetchGoalsRequested);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    Tracking.pageView(
      "Goals",
      location.pathname,
      undefined,
      undefined,
      undefined,
      document.title,
      undefined,
      undefined,
    );
  }, []);

  useEffect(() => {
    fetchGoals(undefined);
  }, [fetchGoals]);

  const handleViewMatches = (goalId: string) => {
    navigate(`/goals/${goalId}/matches`);
  };

  const handleCreateGoal = () => {
    setIsCreateModalOpen(true);
  };

  if (loading) {
    return <Loader message="Loading goals..." />;
  }

  if (error) {
    return (
      <div className="goals-page">
        <div className="error-state">
          <h2>Error loading goals</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (goals.length === 0) {
    return (
      <>
        <SEO title={`Goals | EUcalls`} description={`Goals`} />
        <EmptyState onCreate={handleCreateGoal} />
      </>
    );
  }

  return (
    <>
      <SEO title={`Goals | EUcalls`} description={`Goals`} />
      <div className="goals-page__header">
        <div className="header-content">
          <div>
            <h1>Funding Goals</h1>
            <p>Define your funding goals and discover matching EU calls.</p>
          </div>
        </div>
        <div className="header-actions">
          <Button
            label={goals.length === 0 ? "Create funding goal" : "New goal"}
            icon="pi pi-plus"
            onClick={handleCreateGoal}
          />
        </div>
      </div>

      <div className="goals-page__content">
        <GoalsListComponent
          goals={goals}
          onOpenGoal={() => {}}
          onFindMatches={handleViewMatches}
        />
      </div>

      <CreateGoalModal
        visible={isCreateModalOpen}
        onHide={() => setIsCreateModalOpen(false)}
      />
    </>
  );
};
